// Delete session storage
sessionStorage.removeItem('kotm_stage');
sessionStorage.removeItem('kotm_character');

const urlParams = new URLSearchParams(window.location.search);
const param = urlParams.get('debug') ? '?debug=1' : '';

const buttons = document.querySelectorAll('a.btn');

buttons.forEach(button => {

  button.addEventListener('click', function (event) {
    
    // Stop the browser from navigating immediately
    event.preventDefault();
    
    // Set sessionStorage variable
    sessionStorage.setItem('kotm_stage', button.getAttribute('data-stage'));
    
    // Manually launch the page using the anchor's href
    window.location.href = this.href + param; 

  });

});

const introDialog = document.querySelector('.intro-dialog');
// Wait for 400ms
setTimeout(() => {
  introDialog.showModal(); 
}, 400);

const startGameBtn = document.querySelector('.start-game-btn');

startGameBtn.onclick = () => {
  const video = document.getElementById("video");
  // Pause video before closing dialog
  video.pause();
  return introDialog.close();
};

var mobileCarousel = new Splide('.splide', {
  type: 'fade',
  pagination: false,
  rewind: true
});

mobileCarousel.mount();